import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { EXPERIMENTS } from './experiments';
import { i18n } from './i18n';
import { SHOT_PRESETS } from './screenshot-presets';
import type { ExperimentKey, FuncContext } from './types';

const ORDER = Object.keys(EXPERIMENTS) as ExperimentKey[];

bootstrapDemoShell({
  slug: 'functions',
  i18n,
  experiments: EXPERIMENTS,
  order: ORDER,
  eyebrowKey: 'app.eyebrow',
  helpLineKeys: ['hint.line1', 'hint.line2'],
  shotToExperiment: (id) => (SHOT_PRESETS.some((p) => p.id === id) ? (id as ExperimentKey) : null),
  extendContext: (base): FuncContext => base,
});
